import React, { useState, useEffect } from "react";
import "./PredictionTimeSection.scss";
import moment from "moment";
import { ReactComponent as Special } from "./../../images/Icons/icons-special-events.svg";
import { ReactComponent as Unplanned } from "./../../images/Icons/icons-unplanned-disruption.svg";
import { ReactComponent as Planned } from "./../../images/Icons/icons-planned-disruption.svg";
import specialImgSrc from "./../../images/Icons/Events.png";
import unplannedImgSrc from "./../../images/Icons/Unplanned.png";
import plannedImgSrc from "./../../images/Icons/Planned.png";
import { throttle } from "lodash";

function PredictionTimeSection(props) {
  const { prediction, className } = props;
  const emptySection = (
    <div className="arrival-info">
      <span></span>
    </div>
  );
  const [isTimeAvailable, setIsTimeAvailable] = useState(false);
  const [events, setEvents] = useState([]);
  const [noTimeIconMaxWidth, setNoTimeIconMaxWidth] = useState("100%");

  useEffect(() => {
    if (prediction) {
      // Process if Time is Available
      if ("IsTTAvailable" in prediction && prediction.IsTTAvailable) {
        setIsTimeAvailable(true);
      } else {
        setIsTimeAvailable(false);
      }

      let _tempEvents = [];
      if ("HasDisruption" in prediction && prediction.HasDisruption) {
        _tempEvents.push({
          component: Unplanned,
          imgSrc: unplannedImgSrc,
          className: "unplanned-disruption",
        });
      }
      if ("HasPlannedOccupation" in prediction && prediction.HasPlannedOccupation) {
        _tempEvents.push({
          component: Planned,
          imgSrc: plannedImgSrc,
          className: "planned-occupation",
        });
      }
      if ("HasSpecialEvent" in prediction && prediction.HasSpecialEvent) {
        _tempEvents.push({
          component: Special,
          imgSrc: specialImgSrc,
          className: "special-event",
        });
      }

      setEvents(_tempEvents);
    }
  }, [prediction]);

  const updateNoTimeIconSize = () => {
    const svgIconEl = document.querySelector(".disruption-message svg");
    if (svgIconEl) {
      setNoTimeIconMaxWidth(`${svgIconEl.clientHeight}px`);
    }
  };

  useEffect(() => {
    updateNoTimeIconSize();
  });

  useEffect(() => {
    window.addEventListener("resize", throttle(updateNoTimeIconSize, 500));
    return () => window.removeEventListener("resize", updateNoTimeIconSize);
  });

  if (typeof prediction === "undefined") {
    return emptySection;
  }

  let arrivalTimeFormatted = "–";
  if (isTimeAvailable && prediction.PredictedArrivalDateTime) {
    const formatted = formatArrivalTime(prediction.PredictedArrivalDateTime);
    arrivalTimeFormatted = formatted === "Invalid date" ? "–" : formatted;
  }

  const renderEventIcon = (Component) => {
    return (
      <Component
        className="event-svg-icon"
        style={{ maxHeight: isTimeAvailable ? "100%" : noTimeIconMaxWidth }}
      />
    );
  };

  const EventIconComponent = () => {
    if (Array.isArray(events) && events.length === 0) {
      return null;
    } else {
      return (
        <div className="event-icon-list">
          {events.map((eventIcon) => (
            <div className="event-icon" key={eventIcon.className}>
              {eventIcon &&
                "component" in eventIcon &&
                renderEventIcon(eventIcon.component)}
              {eventIcon && "imgSrc" in eventIcon && (
                <img src={eventIcon.imgSrc} alt={eventIcon.className} />
              )}
            </div>
          ))}
        </div>
      );
    }
  };

  return (
    <div
      className={
        `arrival-info ${
          events.length > 0 ? events[0].className : ""
        }  ${className} ` +
        (arrivalTimeFormatted.length > 3 ? " small " : "") +
        (isTimeAvailable ? " " : " no-time ")
      }
    >
      <EventIconComponent />
      <span className="arrival-time">{arrivalTimeFormatted}</span>
    </div>
  );
}

const formatArrivalTime = (timestamp) => {
  //Using moment library to do time transformations
  const arrivalTime = moment(timestamp);
  const now = moment();
  if (arrivalTime.diff(now, "seconds") < 60) {
    //In next minute return "now"
    return "now";
  } else if (arrivalTime.diff(now, "minutes") < 60) {
    //In next hour return minutes
    return moment(arrivalTime).diff(now, "minutes");
  } else if (arrivalTime.isSame(now, "day")) {
    //On the same day return hour:minutes am/pm
    return arrivalTime.format("h:mma");
  } else {
    //Not today return day hour:minutes am/pm
    return arrivalTime.format("ddd h:mma");
  }
};
export default PredictionTimeSection;
